import { ReactNode } from 'react';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function DocumentInformation({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="w-full">
      <div className="bg-card dark:bg-card-dark rounded-xl p-6">
        <h3 className="text-base font-semibold text-text dark:text-text-dark mb-4">{title}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-base">{children}</div>
      </div>
    </div>
  );
}

export function DocumentFileLink({ href }: { href: string }) {
  const { t } = useTranslation();
  return (
    <a href={href} target="_blank" rel="noopener noreferrer"
      className="flex items-center gap-1 text-sm text-blue-600 dark:text-blue-400 hover:underline">
      {t('orderHistory.viewFile')}
      <ExternalLink className="w-3.5 h-3.5" />
    </a>
  );
}

export function DocumentInfoField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-wrap gap-3">
      <span className="font-medium text-muted dark:text-muted-dark min-w-[120px]">{label}:</span>
      <span className="text-text dark:text-text-dark font-semibold break-words min-w-0">{children}</span>
    </div>
  );
}
